var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTourDefaultImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 104,
    viewBox: "0 0 185 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 104,
    rx: 10,
    fill: "#a192760D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5002 41.7917V33.625H72.0835V70.375H112.917V41.7917H92.5002ZM80.2502 66.2917H76.1668V62.2083H80.2502V66.2917ZM80.2502 58.125H76.1668V54.0417H80.2502V58.125ZM80.2502 49.9583H76.1668V45.875H80.2502V49.9583ZM80.2502 41.7917H76.1668V37.7083H80.2502V41.7917ZM88.4168 66.2917H84.3335V62.2083H88.4168V66.2917ZM88.4168 58.125H84.3335V54.0417H88.4168V58.125ZM88.4168 49.9583H84.3335V45.875H88.4168V49.9583ZM88.4168 41.7917H84.3335V37.7083H88.4168V41.7917ZM108.833 66.2917H92.5002V62.2083H96.5835V58.125H92.5002V54.0417H96.5835V49.9583H92.5002V45.875H108.833V66.2917ZM104.75 49.9583H100.667V54.0417H104.75V49.9583ZM104.75 58.125H100.667V62.2083H104.75V58.125Z",
    fill: "#a19276"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourDefaultImage);
export default __webpack_public_path__ + "static/media/tour-default-image.149e75b5cb9d7806b630a2837b74ce79.svg";
export { ForwardRef as ReactComponent };